import { api } from '~shared/api/origin';

export type WebPushTokens = {
	endpoint: string;
	encryptionKey: string;
	authenticationKey: string;
};
export const retentionApi = api.injectEndpoints({
	endpoints: (build) => ({
		updateAddresses: build.mutation<
			undefined,
			{ userId: string; webPushToken: WebPushTokens }
		>({
			query: ({ userId, webPushToken }) => ({
				url: `/retention/${userId}/addresses?realm=ai`,
				method: 'PUT',
				body: JSON.stringify({ webPushTokens: webPushToken }),
				headers: {
					'content-type': 'application/json',
				},
			}),
		}),
	}),
});

export const { useUpdateAddressesMutation } = retentionApi;
